// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isObjKey<T extends Record<string, any>>(key: string | number | symbol, obj: T): key is keyof T {
  return key in obj;
}
